import { mapToObject } from '@sama/js-core';
import { every } from '@sama/micro-dash';

export type Modifier = 'altKey' | 'ctrlKey' | 'platform' | 'shiftKey';

export function eventMatches<T extends MouseEvent | KeyboardEvent>(
  event: T,
  filter: Partial<T>,
  modifiers: Modifier[] | 'any',
  platformModifier: 'ctrlKey' | 'metaKey',
) {
  return every(
    getModifiedFilter(filter, modifiers, platformModifier),
    (value, key) => event[key as keyof T] === value,
  );
}

export function resolveModifier(
  modifier: Modifier,
  platformModifier: 'ctrlKey' | 'metaKey',
) {
  if (modifier === 'platform') {
    return platformModifier;
  } else {
    return modifier;
  }
}

function getModifiedFilter<T extends MouseEvent | KeyboardEvent>(
  filter: Partial<T>,
  modifiers: Modifier[] | 'any',
  platformModifier: 'ctrlKey' | 'metaKey',
) {
  if (modifiers === 'any') {
    return filter;
  }

  return {
    altKey: false,
    ctrlKey: false,
    metaKey: false,
    shiftKey: false,
    ...filter,
    ...mapToObject(modifiers, (modifier) => [
      resolveModifier(modifier, platformModifier),
      true,
    ]),
  };
}
